import React from 'react'

import WorkOrdersWidget from '../WorkOrders/WorkOrdersWidget';
import CalendarWidget from '../Calendar/CalendarWiget';
import LatePaymentsWidget from '../Billing/LatePaymentsWidget';
import DashboardShortcutsWidget from '../Shortcuts/DashboardShortcutsWidget';
import CardHolder from '../../helpers/Cards/CardHolder';
import RentProgressWidget from '../Widgets/RentProgressWidget'

import { VacantLeases, WorkOrderNewRequests, ExpiringLeases, FollowUpLeads } from '../../helpers/Cards/Cards';

export default class PropertyManagerDashboard extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        return (
            <div class="dashboard">
                <div class="row">
                    <div class="col-md-12">
                        <CardHolder width="100%" columnCount={4} paddingWidth={15}>
                            <WorkOrderNewRequests clickable={true} />
                            <ExpiringLeases clickable={true} />
                            <VacantLeases clickable={true} />
                            <FollowUpLeads followUp={"follow_up"} clickable={true} />
                        </CardHolder>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-8 col-sm-12 col-xs-12">
                        <WorkOrdersWidget/>
                        <LatePaymentsWidget />
                    </div>
                    <div class="col-md-4 col-sm-12 col-xs-12">
                        <DashboardShortcutsWidget />
                        <RentProgressWidget />
                        <CalendarWidget />
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Dashboards/PropertyManagerDashboard.jsx